import { RocketOutlined } from "@ant-design/icons";
import { Button, Card, Select, Typography } from "@shared/ui";
import { SlidersHorizontal } from "lucide-react";
import styles from "./KeywordSearchCard.module.scss";

const { Text } = Typography;

type KeywordSearchCardProps = {
  keywords: string[];
  onKeywordsChange: (keywords: string[]) => void;
  onExtract: () => void;
  canExtract: boolean;
  isLoading: boolean;
  isSettingsOpen: boolean;
  onToggleSettings: () => void;
};

export function KeywordSearchCard({
  keywords,
  onKeywordsChange,
  onExtract,
  canExtract,
  isLoading,
  isSettingsOpen,
  onToggleSettings,
}: KeywordSearchCardProps) {
  return (
    <Card className={styles.searchCard}>
      <Text className={styles.label}>Keywords / Hashtags to Track</Text>
      <Select
        mode="tags"
        value={keywords}
        onChange={(value) => {
          if (Array.isArray(value)) {
            onKeywordsChange(value.map(String));
          }
        }}
        placeholder="Type a keyword or hashtag and press Enter"
        className={styles.tagsSelect}
        tokenSeparators={[","]}
        notFoundContent={null}
      />
      <div className={styles.actions}>
        <Button
          type="primary"
          icon={<RocketOutlined />}
          onClick={onExtract}
          disabled={!canExtract}
          loading={isLoading}
        >
          Start Deep Extraction
        </Button>
        <Button
          icon={<SlidersHorizontal size={16} />}
          onClick={onToggleSettings}
          type={isSettingsOpen ? "default" : "dashed"}
        >
          Extraction Settings
        </Button>
      </div>
    </Card>
  );
}
